namespace TabAurous.Production {
    export interface ProductionItemsRow {
        TransItemId?: number;
        TransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        VoucherNo?: string;
        OrderTypeId?: number;
        OrderTransId?: number;
        OrderTransItemId?: number;
        ProductId?: number;
        ProductCode?: string;
        HasBom?: boolean;
        ItemTypeId?: number;
        CalcOnId?: number;
        OrderNo?: string;
        CustomerName?: string;
        AttributeId?: number;
        MetalId?: number;
        KaratId?: number;
        Attribute?: string;
        BagNo?: string;
        SubBagNo?: number;
        LotNo?: string;
        CertificateNo?: string;
        Line_No?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        Parts?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        Purity?: number;
        PureWeight?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        UserId?: number;
        LossPercent?: number;
        Loss?: number;
        RefVoucherId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
        StockAllocation?: boolean;
        StartDateTime?: string;
        EndDateTime?: string;
        DepartmentId?: number;
        BOMDetails?: ProductionBOMRow[];
        TreeId?: number;
        TreeItemId?: number;
        TreeNo?: string;
    }

    export namespace ProductionItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Production.ProductionItems';
        export const deletePermission = 'Production:Production:Delete';
        export const insertPermission = 'Production:Production:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:Production:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            OrderTypeId = "OrderTypeId",
            OrderTransId = "OrderTransId",
            OrderTransItemId = "OrderTransItemId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            HasBom = "HasBom",
            ItemTypeId = "ItemTypeId",
            CalcOnId = "CalcOnId",
            OrderNo = "OrderNo",
            CustomerName = "CustomerName",
            AttributeId = "AttributeId",
            MetalId = "MetalId",
            KaratId = "KaratId",
            Attribute = "Attribute",
            BagNo = "BagNo",
            SubBagNo = "SubBagNo",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            Line_No = "Line_No",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            Parts = "Parts",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            Purity = "Purity",
            PureWeight = "PureWeight",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            UserId = "UserId",
            LossPercent = "LossPercent",
            Loss = "Loss",
            RefVoucherId = "RefVoucherId",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            StockAllocation = "StockAllocation",
            StartDateTime = "StartDateTime",
            EndDateTime = "EndDateTime",
            DepartmentId = "DepartmentId",
            BOMDetails = "BOMDetails",
            TreeId = "TreeId",
            TreeItemId = "TreeItemId",
            TreeNo = "TreeNo"
        }
    }
}
